module.exports = __webpack_public_path__ + "img/133.c985a3b7.svg";